import { fetchQuery } from 'react-relay';
import get from 'lodash.get';
import { getBuyerId } from 'dibs-cookie-jar';

import isPageType from '../../../utils/isPageType';
import { PAGE_TYPE } from '../../../utils/pageConstants';

import { launchTradeDesignManagerOnboarding } from './launchTradeDesignManagerOnboarding';
import { tradeDesignManagerOnboardingQuery } from './tradeDesignManagerOnboardingQuery';
import { hasSeenTradeDesignManagerOnboarding } from './helpers';

export const tradeDesignManagerOnboardingRule = ({ relayEnvironment }) => {
    const userId = getBuyerId(document.cookie);

    const isBlacklistedPage = isPageType([
        PAGE_TYPE.CHECKOUT,
        PAGE_TYPE.CHECKOUT_CONFIRMATION,
        PAGE_TYPE.ORDER_MANAGER,
    ]);

    if (!userId || isBlacklistedPage || hasSeenTradeDesignManagerOnboarding()) {
        return Promise.resolve(false);
    }

    return fetchQuery(relayEnvironment, tradeDesignManagerOnboardingQuery, { userId }).then(
        response => {
            const isTradeDMUser =
                get(response, 'viewer.user.isVerifiedTrade') &&
                get(response, 'viewer.user.tradeFirmDesignManagerProfile.hasAccount');
            return isTradeDMUser;
        }
    );
};

export const tradeDesignManagerOnboardingConfig = {
    name: 'tradeGlobalDesignManagerOnboarding',
    rule: tradeDesignManagerOnboardingRule,
    action: launchTradeDesignManagerOnboarding,
    priority: 447,
};
